window.Tally.loadEmbeds();
